import { REACT_APP_API_ENDPOINT_EMAILSEND, REACT_APP_API_ENDPOINT_LOGINGETSESSION } from "../../../Domain/Settings/SettingsVariables";
import { Get } from "../../HTTP/Get";
import * as CryptoJS from "crypto-js";
import { encryptDecrypt, getGeoMok, getNavegator } from "../FeatureGlobal";
import Axios from "axios";
import { Post } from "../../HTTP/Post";

export const FeatureGetSession = (token) => {
    const { AxiosGet } = Get();
    const { AxiosPost } = Post();


    AxiosGet(`${REACT_APP_API_ENDPOINT_LOGINGETSESSION}`,token).then(success => {
      console.log(success)
        localStorage.setItem(
          "user",
          CryptoJS.AES.encrypt(JSON.stringify(success), "eco_scotia")
        );
        var dispo = getNavegator();
        getGeoMok().then(succ => {
          var encrip = btoa(encryptDecrypt(`${succ.data.ip}<${success.idUsuario}`, succ.data.ip));
          let obj = {
            ipUsuario: succ.data.ip,
            dispositivo: dispo,
            link: encrip
          }
          AxiosPost(`${REACT_APP_API_ENDPOINT_EMAILSEND}`, JSON.stringify(obj), true).then(succ => {
            window.location.href = "/homein";
          }).catch(error => {
          });
        }).catch(error => {
          //console.log(error);
        });
      }).catch(error => {
        //console.log(error);
        window.location.href = "/inicia-sesion";
      });
  }